<ng-container
  *ngFor="let chat of chatDetails; let i = index; trackBy: trackByChatId"
>
  <ng-template #relatedQuestionsTemplate let-lastMessage="lastMessage">
    <app-related-questions
      [relatedQuestions]="
        isAIMessage(lastMessage) && lastMessage.follow_up_questions
      "
      (submitRelatedQuestion)="postRelatedQuestions($event)"
    >
    </app-related-questions>
  </ng-template>
  <div
    class="chat__message-container"
    [class.mobile]="(screenSize$ | async)?.isMobile"
  >
    <!-- User Message -->
    <div
      *ngIf="chat.actor === 'human'"
      class="message__container message__container--user"
    >
      <div class="message__avatar-container">
        <div class="message__avatar message__avatar--human">
          {{ userAvatar }}
        </div>
      </div>
      <div
        class="message__textbox message__textbox--human"
        [innerHTML]="chat.message"
      ></div>
      <div *ngIf="chartVisible && !(screenSize$ | async)?.isMobile">
        <div class="container__empty" style="height: 10px"></div>
      </div>
    </div>

    <!-- AI Message -->
    <div
      *ngIf="chat.actor === 'ai'"
      class="message__container message__container--response"
    >
      <div class="message__avatar-container">
        <div class="message__avatar message__avatar--response">
          {{ llmAvatar }}
        </div>
      </div>
      <div class="chat__wrapper">
        <div
          class="message__textbox message__textbox--ai"
          *ngIf="
            (isAIMessage(chat.message) && chat.message) || (!loading && !error)
          "
        >
          <app-chat-message-facts
            [aiMessage]="isAIMessage(chat.message) && chat.message"
            (citationClicked)="
              showTheArticleView(
                chat.message.companyName,
                chat.message.companyType,
                $event.article
              )
            "
          ></app-chat-message-facts>
          <app-article-card-wrapper
            *ngIf="isAIMessage(chat.message)"
            [sourceDocuments]="
              chat.message.source_documents_events ||
              chat.message.source_documents
            "
            [entitiyName]="chat.message.entityName"
            [companyName]="chat.message.companyName"
            [companyType]="chat.message.companyType"
            [requestedEntities]="chat.message.requested_entities"
            [chartVisible]="chartVisible"
            (navigateToCompany)="
              navigateToCompany($event.companyName, $event.companyType)
            "
            (showTheArticleView)="
              showTheArticleView(
                $event.companyName,
                $event.companyType,
                $event.article
              )
            "
          >
          </app-article-card-wrapper>
        </div>
        <div
          class="message__textbox message__textbox--ai"
          *ngIf="i === chatDetails.length - 1 && error"
        >
          <p>Something went wrong, please try again.</p>
        </div>

        <!-- Feedback Box -->
        <div
          class="chat__feedbackbox"
          [ngClass]="{
            'always-visible': i === chatDetails.length - 1,
          }"
        >
          <mat-icon
            class="thumb-icon"
            [ngClass]="{ active: chat.feedback === 1 }"
            (click)="chatFeedback(chat.message_id, 'pos')"
          >
            thumb_up
          </mat-icon>
          <mat-icon
            class="thumb-icon"
            [ngClass]="{ active: chat.feedback === -1 }"
            (click)="chatFeedback(chat.message_id, 'neg')"
          >
            thumb_down
          </mat-icon>
        </div>
        <!-- Related Questions -->
        <div
          *ngIf="
            i === chatDetails.length - 1 && !(screenSize$ | async)?.isMobile
          "
        >
          <ng-container
            *ngTemplateOutlet="
              relatedQuestionsTemplate;
              context: { lastMessage: chat.message }
            "
          >
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="chat.actor === 'ai' && shouldShowChatCharts(chat.message)">
      <app-chat-charts
        [isVisible]="chartVisible"
        (visibilityChange)="updateChartVisibility($event)"
        [childChat]="chat.message"
      >
      </app-chat-charts>
      <div>
        <div
          *ngIf="!chartVisible && !(screenSize$ | async)?.isMobile"
          class="charts__icon charts__icon--open"
          id="chat-open-charts"
          (click)="updateChartVisibility(true)"
        >
          <mat-icon>keyboard_arrow_right</mat-icon>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        chat.actor === 'ai' &&
        !shouldShowChatCharts(chat.message) &&
        !(screenSize$ | async)?.isMobile
      "
    >
      <div
        class="container__empty"
        [ngClass]="{ 'closed-charts': !chartVisible }"
      ></div>
    </div>
    <div
      *ngIf="i === chatDetails.length - 1 && (screenSize$ | async)?.isMobile"
    >
      <ng-container
        *ngTemplateOutlet="
          relatedQuestionsTemplate;
          context: { lastMessage: chat.message }
        "
      >
      </ng-container>
    </div>
  </div>
</ng-container>

<div *ngIf="loading && !error" class="message__container">
  <div class="message__avatar-container">
    <div class="message__avatar message__avatar--response">
      {{ llmAvatar }}
    </div>
  </div>
  <app-chat-loader></app-chat-loader>
</div>
